export default {
	'--color1v1': '#eb4848',
	'--color1v2': '#cf2626',
	'--color1v1Border': '#cf2626',
	'--color1v2Border': '#b52020',
	'--color1Text': 'white',

	'--color2v1': '#ba8a12',
	'--color2v2': '#966512',
	'--color2v1Border': '#966512',
	'--color2v2Border': '#7c5017',
	'--color2Text': 'white',

	'--inputColor': '#cdabab',
	'--inputText': 'black',

	'--disabledButton': '#ced1d3',
	'--disabledButtonBorder': '#a9aeb1',
	'--disabledButtonText': 'black',

	'--footerbg': 'black',
	'--footerText': 'white',

	'--headerColor': '#3f3c3c',
	'--headerText': 'white',
	'--navButtonBorder': 'white',

	'--backgroundColor': '#282525',
	'--backgroundColorText': 'white'
} as React.CSSProperties;
